// Typed reviewer-entered values for a change item's field (SAD-395): which
// control a field gets, and how the typed text becomes the decided_value_json
// ResolveDiscrepancy -> pangaea approved_value_json -> ApplyChangeSet expects.
// Shared by ModificationCenter's Corrected input and the review-item panel.
// Every money-valued field a reviewer might be correcting or reading, across
// periods, CLINs, deliverables and the contract.
const CORRECTED_MONEY_FIELDS = new Set([
    'funded_amount',
    'total_amount',
    'extended_price',
    'unit_price',
    'funded_amount_contribution',
    'funded_ceiling',
    'nte_ceiling',
    'total_ceiling'
]);
// Whether a field holds dollars, so its value is always shown in cents
// (recordLabels.formatMoney).
export function isMoneyField(field) {
    return CORRECTED_MONEY_FIELDS.has(field);
}
// Any field ending in "_date" (period start/end, deliverable due_date, CLIN
// pop dates) is a date; the known money fields are numbers; everything else is
// free text.
export function correctedFieldKind(field) {
    if (field.endsWith('_date')) return 'date';
    if (CORRECTED_MONEY_FIELDS.has(field)) return 'number';
    return 'text';
}
// Empty input always serializes to '' so a submit button can gate on it
// directly.
export function correctedValueJson(field, raw) {
    const kind = correctedFieldKind(field);
    if (kind === 'date') return raw ? JSON.stringify(raw) : '';
    if (kind === 'number') {
        if (raw === '') return '';
        const n = Number(raw);
        return Number.isFinite(n) ? String(n) : '';
    }
    if (!raw) return '';
    try {
        JSON.parse(raw);
        return raw; // already valid JSON (e.g. a reviewer-pasted object/array) — keep verbatim.
    } catch  {
        return JSON.stringify(raw);
    }
}
// S5b-2 teaches the strict apply path both shapes. Keeping the wire shape here
// gives this panel one seam to remove or revise if that backend contract moves.
export function teamCorrectedValueJson(selection) {
    if ('workstreamId' in selection) {
        return JSON.stringify({
            workstream_id: selection.workstreamId
        });
    }
    const name = selection.newTeamName.trim();
    return name ? JSON.stringify({
        new_team: {
            name
        }
    }) : '';
}
